import { render, staticRenderFns } from "./ListShippingServices.vue?vue&type=template&id=82d3bdfa&scoped=true"
import script from "./ListShippingServices.vue?vue&type=script&lang=js"
export * from "./ListShippingServices.vue?vue&type=script&lang=js"
import style0 from "./ListShippingServices.vue?vue&type=style&index=0&id=82d3bdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d3bdfa",
  null
  
)

export default component.exports